import type { SiteConfig } from '../../@types/context/site-config.types';
import { serviceTrustpilotAxoConfig } from './service-trustpilot-axo.config';

export const serviceTrustpilotAxoFiConfig: SiteConfig['services']['trustpilot'] =
  {
    ...serviceTrustpilotAxoConfig,
    businessUnitId: '5d949991dff97e00014e194b',
  };
